@if (design4) {
  <ng-container [ngTemplateOutlet]="DESIGN_4"></ng-container>
} @else {
  <ng-container [ngTemplateOutlet]="DESIGN_2"></ng-container>
}
<ng-template #DESIGN_2>
  <app-page-header
    [charity]="charity"
    [territory]="organization"
    title="Please fill in your information."
    subtitle="This is needed for Resupply to send you confirmation details and update notifications."
    [hasBack]="hasBack"
    (onBack)="back()"
  ></app-page-header>
  <div class="page-content" fxLayout="column" fxLayoutAlign="start start">
    <div class="donor-info step-content" fxLayout="column" fxLayoutAlign="center center" fxLayoutAlign.xs="start center">
      <app-info-form [form]="form" />
      <mat-checkbox class="sms-checkbox" color="primary" [checked]="smsApproval" (change)="smsApproval = !smsApproval">
        Check this box to receive up to two SMS updates from Resupply Inc. about the impact of your donation on non-profits in your area
        (standard message rates may apply). See our
        <a (click)="smsDialog($event)">SMS Texts Policy</a>
        for details. Understand that you can unsubscribe anytime by replying STOP to any message received.
      </mat-checkbox>
      <div fxLayoutAlign="center center">
        <button id="step3Submission" class="primary-btn warn-btn filled-btn" (click)="saveLead()" [ladda]="isSubmitting">Next Step</button>
      </div>
    </div>
    <div fxLayout="column" fxLayout.gt-sm="row" class="progress-wrapper">
      <app-create-progress fxFlex [step]="flowStep" [flowConfiguration]="flowConfiguration" />
    </div>
  </div>
</ng-template>
<ng-template #DESIGN_4>
  <div class="page-content" fxLayout="column" fxLayoutAlign="start start">
    <div fxLayout="column" fxLayout.gt-sm="row" class="progress-wrapper">
      <app-create-progress fxFlex [step]="flowStep" [flowConfiguration]="flowConfiguration" />
    </div>
    <div class="donor-info step-content" fxLayout="column" fxLayoutAlign="center center" fxLayoutAlign.xs="start center">
      <div fxLayout="column">
        <h1>Additional Contact and Pickup Information</h1>
        <h3>
          Please provide additional contact and pickup details for coordinating your pickup. We’ll only share your information with your
          assigned driver on the day of pickup.
        </h3>
      </div>
      <app-info-form [form]="form" />
      <mat-checkbox class="sms-checkbox" color="primary" [checked]="smsApproval" (change)="smsApproval = !smsApproval">
        Check this box to receive up to two SMS updates from Resupply Inc. about the impact of your donation on non-profits in your area
        (standard message rates may apply). See our
        <a (click)="smsDialog($event)">SMS Texts Policy</a>
        for details. Understand that you can unsubscribe anytime by replying STOP to any message received.
      </mat-checkbox>
    </div>
    <app-page-footer (onSubmit)="saveLead()" [hasBack]="hasBack" (onBack)="back()"></app-page-footer>
  </div>
</ng-template>
